import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { apiErr } from "@/lib/format";
import { toast } from "sonner";

/** Inicio del Representante Técnico Comercial: solo su alcance (regiones asignadas), sin costos. */
export default function RtcPanel() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/rtc/mi-panel").then(({ data }) => setD(data)).catch((e) => { toast.error(apiErr(e)); setD({}); });
  }, []);
  if (!d) return <div className="text-text-muted">Cargando…</div>;
  const regiones = (d.regiones_detalle || []).map((r) => r.nombre || r.codigo);
  const Card = ({ l, v, sub, to, tid }) => (
    <button onClick={() => to && navigate(to)} data-testid={tid}
      className="text-left bg-card border border-border/60 rounded-2xl p-5 hover:border-agro-green/40 transition">
      <div className="text-[10px] uppercase tracking-[0.18em] text-text-muted">{l}</div>
      <div className="font-heading text-2xl mt-1">{v}</div>
      {sub && <div className="text-xs text-text-secondary mt-1">{sub}</div>}
    </button>
  );
  return (
    <div className="space-y-5" data-testid="rtc-panel">
      <div className="bg-card border border-border/60 rounded-2xl p-5">
        <div className="text-[10px] uppercase tracking-[0.18em] text-text-muted">Regiones asignadas</div>
        {regiones.length ? (
          <div className="flex flex-wrap gap-2 mt-2">{regiones.map((r) => <span key={r} className="px-2.5 py-1 rounded border border-agro-green/40 text-agro-green text-xs">{r}</span>)}</div>
        ) : (
          <div className="text-sm text-agro-yellow mt-2" data-testid="rtc-sin-regiones">
            Aún no tienes regiones asignadas: no verás clientes hasta que el Administrador General te las asigne.
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Card l="Mis clientes" v={d.clientes ?? 0} to="/clientes" tid="rtc-kpi-clientes" />
        <Card l="Traslados en curso" v={d.traslados_pendientes || 0} to="/inventario/solicitudes-traslado" tid="rtc-kpi-traslados" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-card border border-border/60 rounded-2xl p-5">
          <div className="text-[10px] uppercase tracking-[0.18em] text-text-muted mb-2">Mis proformas</div>
          <Estados obj={d.proformas} labels={{ borrador: "Borrador", pendiente: "Pendientes de aprobación", devuelta: "Devueltas para corrección", aprobada: "Aprobadas", rechazada: "Rechazadas" }} />
          <button onClick={() => navigate("/ventas")} className="mt-3 text-xs text-agro-green">Ir a proformas →</button>
        </div>
        <div className="bg-card border border-border/60 rounded-2xl p-5">
          <div className="text-[10px] uppercase tracking-[0.18em] text-text-muted mb-2">Mis cobros</div>
          <Estados obj={d.cobros} labels={{ borrador: "Borrador", pendiente: "Pendientes de aprobación", devuelto: "Devueltos para corrección", autorizado: "Aprobados", rechazado: "Rechazados" }} />
          <button onClick={() => navigate("/cxc")} className="mt-3 text-xs text-agro-green">Ir a cobros →</button>
        </div>
      </div>
    </div>
  );
}

function Estados({ obj = {}, labels }) {
  return (
    <ul className="text-sm space-y-1">
      {Object.entries(labels).map(([k, l]) => (
        <li key={k} className="flex justify-between"><span className="text-text-secondary">{l}</span><span className="font-medium">{obj?.[k] || 0}</span></li>
      ))}
    </ul>
  );
}
